import { render, staticRenderFns } from "./InternationalConsulting.vue?vue&type=template&id=f9ea9ac2&"
import script from "./InternationalConsulting.vue?vue&type=script&lang=js&"
export * from "./InternationalConsulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports